module.exports = __webpack_public_path__ + "static/media/fistLogo.d9150ac2.png";